export default __webpack_public_path__ + "static/icons-e1fcec5d673b49eeb7375b5bbb0b3a5f.svg";